"use strict";

const isDocumentId = ( id='' ) => {
    const regex = /^D-[0-9A-Z]{8}$/i;
    return regex.test( id );
};

export default isDocumentId;
